import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function AirportIcon(props) {
  return (
    <SvgIcon viewBox="0 0 20 20" title="Airports" {...props}>
      <path d="M6.75 20V18.95L8.75 17.45V11.175L0 13.75V12.3L8.75 7.15V1.25C8.75 0.9 8.87083 0.604167 9.1125 0.3625C9.35417 0.120833 9.65 0 10 0C10.35 0 10.6458 0.120833 10.8875 0.3625C11.1292 0.604167 11.25 0.9 11.25 1.25V7.15L20 12.3V13.75L11.25 11.175V17.45L13.25 18.95V20L10 19.075L6.75 20Z" />
    </SvgIcon>
  );
}

export default AirportIcon;
